// extracted by mini-css-extract-plugin
export default {"bar":"RouteStatsBar_bar__wbKfR","stat":"RouteStatsBar_stat__r-74E","label":"RouteStatsBar_label__8LBEo","value":"RouteStatsBar_value__zXJfI"};